module.exports = __webpack_public_path__ + "img/homeBanner.f623e9cd.png";